import type { ComponentType } from "react";
import { Card } from "@hotelise/ui";

interface Props {
	value: number | string;
	title: string;
	icon?: ComponentType<{ className?: string }>;
	isDestructive?: boolean;
}

const SummaryItem = (props: Props) => {
	const { value, title, icon: IconComponent, isDestructive } = props;

	const formatTitle = (text: string) => {
		const abbreviations = ["ADR", "ALOS", "KPI", "USD", "AMD", "RevPAR"];
		if (abbreviations.includes(text)) return text;
		if (text === "RevPAR") return "RevPAR";
		return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	};

	const displayTitle = formatTitle(title);

	return (
		<Card className="bg-transparent p-5 md:p-4 flex flex-col border-border rounded-lg transition-all relative">
			<div className="flex justify-between items-start mb-3 md:mb-2">
				<p className="text-sm md:text-xs font-semibold text-muted-foreground tracking-wide">
					{displayTitle}
				</p>
				{IconComponent && (
					<div className="opacity-70">
						<IconComponent className="h-[18px] w-[18px] text-muted-foreground/70" />
					</div>
				)}
			</div>
			<p className="text-2xl md:text-lg font-bold text-foreground">
				{value}
			</p>
		</Card>
	);
};

export default SummaryItem;
